export default {"src":"/_next/static/media/MY_v3.73d95def.svg","height":36,"width":54,"blurWidth":0,"blurHeight":0};